import { useMemo } from "react";
import SelectInput from "components/common/inputs/SelectInput";
import TextInput from "components/common/inputs/TextInput";
import { useForm } from "contexts/FormContext";

const ADDRESS_PREFIX = {
  Ship: {
    state: "ShipState",
    city: "ShipCity",
    county: "ShipCounty",
    street1: "ShipStreet1",
    street2: "ShipStreet2",
    selectPrefix: "shipping-address",
    line1Name: "shipping-address-line-1",
    line2Name: "shipping-address-line-2",
  },
  Bill: {
    state: "BillState",
    city: "BillCity",
    county: "BillCounty",
    street1: "BillStreet1",
    street2: "BillStreet2",
    selectPrefix: "billing-address",
    line1Name: "billing-address-line-1",
    line2Name: "billing-address-line-2",
  },
};

export default function CnFormAddressFields({
  addressType = "Ship",
  states = [],
  cities = [],
  counties = [],
  listArray = [],
}) {
  const { form, setForm, inputOnChange, validateForm } = useForm();
  const keys = ADDRESS_PREFIX[addressType];

  const onStateChange = useMemo(
    () => (e) => {
      const { id } = e.target;
      setForm({
        ...form,
        [keys.state]: id,
        [keys.city]: "",
        [keys.county]: "",
      });
    },
    [form, keys.city, keys.county, keys.state, setForm]
  );

  const onCityChange = useMemo(
    () => (e) => {
      const { id } = e.target;
      setForm({
        ...form,
        [keys.city]: id,
        [keys.county]: "",
      });
    },
    [form, keys.city, keys.county, setForm]
  );

  const onCountyChange = useMemo(
    () => (e) => {
      const { id } = e.target;
      setForm({ ...form, [keys.county]: id });
    },
    [form, keys.county, setForm]
  );

  return (
    <>
      <SelectInput
        selectId={`${keys.selectPrefix}-state`}
        labelText={listArray[0]?.fields?.name}
        options={states}
        value={form[keys.state]}
        onChange={onStateChange}
      />
      <SelectInput
        selectId={`${keys.selectPrefix}-city`}
        labelText={listArray[1]?.fields?.name}
        options={cities}
        value={form[keys.city]}
        onChange={onCityChange}
      />
      <SelectInput
        selectId={`${keys.selectPrefix}-county`}
        labelText={listArray[2]?.fields?.name}
        options={counties}
        value={form[keys.county]}
        onChange={onCountyChange}
      />
      <TextInput
        inputId={keys.street1}
        inputName={keys.line1Name}
        inputValue={form[keys.street1]}
        inputOnChange={inputOnChange}
        inputOnBlur={validateForm}
        label={listArray[3]?.fields?.name}
        helperText={listArray[3]?.fields?.helperText}
        inputErrorText={listArray[3]?.fields?.errorText}
        dynamicHelperText
        maxLength={50}
        required
      />
      <TextInput
        inputId={keys.street2}
        inputName={keys.line2Name}
        inputValue={form[keys.street2]}
        inputOnChange={inputOnChange}
        inputOnBlur={validateForm}
        label={listArray[4]?.fields?.name}
        helperText={listArray[4]?.fields?.helperText}
        inputErrorText={listArray[4]?.fields?.errorText}
        dynamicHelperText
        maxLength={50}
      />
    </>
  );
}
